import { render, staticRenderFns } from "./ItemReturnsReport.vue?vue&type=template&id=31a8c44a&"
import script from "./ItemReturnsReport.vue?vue&type=script&lang=js&"
export * from "./ItemReturnsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports